// FetchOffersOverview POST /api/2.0/offers/fetch_offers_overview
import { api } from "services/api/service";
import { API_FETCH_ACTIVE_OFFERS, API_BULK_OFFER_ISSUANCE } from "constants/api";
import type { ApiResponse } from "services/api/types";

export const getActiveOffers = async (): Promise<ApiResponse<any>> => {
	return (await api()).post(API_FETCH_ACTIVE_OFFERS, {
		exclude_sub_category: ["cagfunded"]
	});
};

interface Payload {
	member: boolean;
	card_numbers?: string[];
	card_start_range?: string;
	card_end_range?: string;
	quantity_of_offers?: number;
	start_date?: string;
	end_date?: string;
	offer?: string;
	remarks?: string;
}
export const bulkOfferIssuance = async (payload: Payload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_BULK_OFFER_ISSUANCE, payload);
};
